import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

const root = createRoot(document.getElementById("root")!);
root.render(
  <HelmetProvider><App /></HelmetProvider>
);

// Signal prerender that the app has rendered
requestAnimationFrame(() => {
  document.dispatchEvent(new Event("render-event"));
});
